import styled from "styled-components";
export const UiTreeSelect = styled.label`
	position: relative;
	display: block;

	> .label {
		margin-bottom: 1px;
		color: rgba(0, 0, 0, 0.65);
	}
`;